<div class="access-denied-message">
  <div class="access-denied-message__text">{{whenDisabledMessage}}</div>
  <button mat-button class="btn btn-red"  (click)="onClose()">ЗАКРЫТЬ</button>
</div>
